export const MAX_CANNED_RESPONSE_IMAGES = 10;
export const CANNED_RESPONSE_IMAGE_TYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
];

export const cannedResponseFormData = ({
  short_code: shortCode,
  content,
  images = [],
  removedImageIds = [],
}) => {
  const data = new FormData();
  if (shortCode !== undefined)
    data.append('canned_response[short_code]', shortCode);
  if (content !== undefined) data.append('canned_response[content]', content);
  images.forEach(file => data.append('canned_response[images][]', file));
  removedImageIds.forEach(id =>
    data.append('canned_response[removed_image_ids][]', id)
  );
  return data;
};

export const cannedResponseAttachments = (images, conversationId, isPrivate) =>
  images.map(image => ({
    id: `canned-image-${image.id}`,
    currentChatId: conversationId,
    isPrivate,
    resource: image,
    thumb: image.url,
    blobSignedId: image.signed_id,
  }));
